import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { getAllProjects } from '../../../../redux/features/courseSlice';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import { coursePerformanceAnalyticsHeader } from './utils/coursePerfomanceAnalyticsHeader';
import { getCoursePerfomanceAnalytics } from '../../../../redux/features/crdMigrationSlice';

export default function CoursePerfomanceAnalytics() {
  // normal variable
  const dispatch = useDispatch();

  // Redux State-------------------------------------------------------------
  const allProjects = useSelector((state) => state.course.projects);
  const projectLoading = useSelector((state) => state.course.loading);
  const loading = useSelector((state) => state.crdMigration.coursePerfomanceAnalyticsTable.loading);
  const coursePerfomanceAnalyticsTable = useSelector((state) => state.crdMigration.coursePerfomanceAnalyticsTable.data);
  const meta = useSelector((state) => state.crdMigration.coursePerfomanceAnalyticsTable.meta);
  //--------------------------------------------------------------------------

  // react state
  const [project, setProject] = useState({ id: -1, name: 'All' });
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  // EXCEPT CRO ---------------------------------------------
  useEffect(() => {
    dispatch(getAllProjects());
  }, []);
  // ---------------------------------------------------------

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      project_id: project?.id === -1 ? null : project?.id,
      page: tableState?.page,
      limit: tableState?.pageSize,
      fromDate,
      toDate,
      search: tableState?.search,
      sortBy: tableState?.sort?.field,
      sortOrder: tableState?.sort?.direction,
    }),
    [project, tableState?.page, tableState?.search, tableState?.sort, tableState?.pageSize, fromDate, toDate],
  );

  //---------* =-=-=-==-=--=-=-=-=- *---------------------------

  //-------------- Table Fetch ------------------------------
  useEffect(() => {
    dispatch(getCoursePerfomanceAnalytics(dispatchParams));
  }, [dispatchParams, dispatch]);
  //-------------* Table Fetch *-----------------------------

  return (
    <GlobalWrapper title={'Course Performance Analytics'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <FromAndToDatePicker fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setToDate={setToDate} />
          <GlobalSelectFieldWithoutFormikNew
            label={'Project'}
            data={[{ id: -1, name: 'All' }, ...allProjects]}
            keys={{
              itemId: 'id',
              itemValue: 'name',
            }}
            selectedDetails={project}
            setChange={setProject}
            sx={{
              width: { xs: '100%', sm: 200 },
            }}
            disabled={projectLoading}
          />
        </Stack>
        <GlobalTable
          rowUniqueId="sl_no"
          headers={coursePerformanceAnalyticsHeader}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={coursePerfomanceAnalyticsTable}
          meta={meta}
        />
      </Stack>
    </GlobalWrapper>
  );
}
